import actions from './pt-br/actions'
import drawer from './pt-br/drawer'
import filters from './pt-br/filters'
import forms from './pt-br/forms'
import reports from './pt-br/reports'
import resources from './pt-br/resources'
import routes from './pt-br/routes'
import httpErrors from './pt-br/httpErrors'
import permissions from './pt-br/permissions'

export default {
    actions: actions,
    drawer: drawer,
    filters: filters,
    forms: forms,
    httpErrors: httpErrors,
    reports: reports,
    resources: resources,
    routes: routes,
    permissions: permissions,

    'app-layout': {
        texts: {
            dashboard: 'Dashboard',
            'loading-application': 'Carregando aplicação...',
            exit: 'Sair',
            whitelabel: 'White Label CPlug',
            resale: 'Parceiros CPlug',
        },
    },

    'money-config': {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        allowBlank: true,
        defaultValue: null,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
    },

    'percent-config': {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '%',
        precision: 2,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
    },

    'int-config': {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
    },

    resellers: {
        types: {
            reseller: 'Revendedor',
            partner: 'Parceiro',
            whitelabel: 'White Label',
        },
    },

    form: {
        'add-prefix': 'Adicionar',
        'edit-prefix': 'Editar',
        actions: {
            back: 'Voltar',
            save: 'Salvar',
            edit: 'Editar',
            delete: 'Remover',
            create: 'Criar',
            show: 'Ver detalhes',
            no_action_available: 'Nenhuma ação adicional disponível',
            restore: 'Restaurar',
            download: 'Baixar',
        },
        messages: {
            'validation-error': 'Preencha o formulário corretamente.',
        },
        status: {
            active: 'Ativo',
            disabled: 'Inativo',
            yes: 'Sim',
            no: 'Não',
        },
        buttons: {
            clean: 'Limpar',
            save: 'Salvar',
        },
        'validation-error': 'Preencha o formulário corretamente.',
        filters: {
            male: {
                all: 'Todos',
                active: 'Ativos',
                inactive: 'Inativos',
            },
            female: {
                all: 'Todas',
                active: 'Ativas',
                inactive: 'Inativas',
            },
        },
        create: {
            'title-prefix': 'Adicionar',
        },
        edit: {
            'title-prefix': 'Editar',
        },
    },

    tables: {
        actions: 'Ações',
    },

    partner: {
        routes: {
            index: 'parceiros',
            create: 'parceiros/criar',
            edit: 'parceiros/editar',
            show: 'parceiros/dados',
        },
        breadcrumbs: {
            index: 'Parceiros',
            create: 'Criar',
            edit: 'Editar',
            show: 'Dados',
        },
        type: {
            all: 'Todos',
            traditional: 'Tradicional',
        },
        status: {
            active: 'Ativo',
            blocked: 'Bloqueado',
            pending: 'Pendente',
            'partners-without-activation': 'Sem ativação',
            trashed: 'Cancelados',
        },
        index: {
            buttons: {
                create: 'Adicionar Parceiro',
            },
            table: {
                company: 'Empresa',
                'tenant-code': 'Código',
                'legal-name': 'Razão Social',
                'trade-name': 'Nome Fantasia',
                name: 'Nome',
                'contact-name': 'Contato',
                email: 'Email',
                phone: 'Telefone',
                lastAccess: 'Último acesso',
                type: 'Tipo',
                'crated-at': 'Criado em',
                document: 'Documento',
                'last-activation': 'Última Ativação',
                days: 'dia(s)',
            },
            loading: 'Carregando...',

            bus: {
                'delete-error': 'Erro ao remover o parceiro {partner}.',
                'delete-success': 'Parceiro {partner} removido com sucesso.',
            },

            messages: {
                delete: 'Cancelar?',
                'delete-confirmation':
                    'Tem certeza que deseja cancelar o contrato do parceiro {partner} ? <br /><br />',
                restore: 'Restaurar?',
                'restore-confirmation':
                    'Funcionalidade ainda não implementada.',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
        show: {
            texts: {
                addresses: 'Endereços',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Parceiro',
            },

            labels: {
                'legal-name': 'Razão Social',
                'trade-name': 'Nome Fantasia',
                cnpj: 'CNPJ',
                cpf: 'CPF',
                website: 'Domínio',
                'cplug-domain': 'Subdomínio',
                'type-text': 'Tipo de parceiro',
                'contact-name': 'Nome Contato',
                email: 'Email',
                phone: 'Telefone',
                observation: 'Observação',
                'erp-schema': 'Schema no ERP',
                po: 'PO',
                'block-at': 'Bloquear em',
                'block-reason': 'Motivo do bloqueio',
                cnae: 'Cnae (Código de NF)',
                'inscricao-estadual': 'Inscrição Estadual',
                'inscricao-municipal': 'Inscrição Municipal',
                'self-managed': 'Auto gerenciado',
            },

            actions: {
                details: 'Ver detalhes',
                reports: 'Relatórios',
                delete: 'Cancelar Contrato',
                restore: 'Restaurar Contrato',
            },

            buttons: {
                clean: 'Limpar',
                save: 'Salvar',
            },

            bus: {
                'save-success': 'Parceiro {partner} salvo com sucesso.',
            },

            messages: {
                'legalName-error-required':
                    'A razão social é obrigatorio quando cnpj está preenchido.',
                'tradeName-error-required': 'O nome fantasia é obrigatorio',
                'cnpj-error-required':
                    'O cnpj é obrigatório quando cpf não está preenchido',
                'cnpj-error-length': 'Informe o cnpj corretamente',
                'cnae-error-required': 'O cnae é obrigatório',
                'inscricao-estadual-error-required':
                    'A inscrição estadual é obrigatória',
                'inscricao-municipal-error-required':
                    'A inscrição municipal é obrigatória',
                'cpf-error-required':
                    'O cpf é obrigatório quando cnpj não está preenchido',
                'cpf-error-length': 'Informe o cpf corretamente',
                'website-error-required': 'O domínio é obrigatório',
                'cplugDomain-error-required': 'O subdomínio ó obrigatório',
                'typeText-error-required': 'O tipo é obrigatório',
                'contactName-error-required': 'O nome do contato é obrigatório',
                'email-error-required': 'O email é obrigatório',
                'email-error-email': 'O email deve ser válido',
                'phone-error-required': 'O telefone é obrigatório',
                'status-error-required': 'O status é obrigatório',
                'phone-error-min-length':
                    'O telefone deve conter no mínimo 10 números',
                'block-alert':
                    '<strong>Atenção!</strong> Lembre que é preciso desativar a conta do parceiro no ERP.',
            },
        },

        customers: {
            'trade-name': 'Nome Fantasia',
            show: 'Ver detalhes',
        },
    },

    customer: {
        routes: {
            index: 'clientes',
            edit: 'clientes/editar',
            show: 'clientes/dados',
        },
        breadcrumbs: {
            index: 'Clientes',
            edit: 'Editar',
            show: 'Detalhes',
        },

        title: '{title-prefix} Cliente',

        index: {
            table: {
                resellers: 'Parceiro',
                'legal-name': 'Razão Social',
                'trade-name': 'Nome Fantasia',
                document: 'Documento',
                customer: 'Cliente',
                name: 'Nome',
                contacts: 'Contatos',
                email: 'Email',
                phone: 'Telefone',
                history: 'Histórico',
                status: 'Status',
                created: 'Criação',
                activated: 'Ativação',
                deleted: 'Deletado',
                trial: 'Trial expira em',
            },

            messages: {
                'show-login-info': 'Exibir informações de login',
                'show-details': 'Ver detalhes',
                restore: 'Restaurar cliente?',
                'restore-confirmation':
                    'Tem certeza que deseja restaurar o cliente {name}',
            },

            bus: {
                'restore-error': 'Erro ao restaurar o cliente {name}.',
                'restore-success': 'Cliente {name} restaurado com sucesso.',
            },
        },

        status: {
            all: 'Todos',
            active: 'Ativo',
            actives: 'Ativos',
            'bad-debit': 'Inadimplentes',
            blocked: 'Bloqueado',
            blockeds: 'Bloqueados',
            trial: 'Trial',
            trials: 'Trials',
            expired: 'Expirado',
            deleted: 'Excluído',
            deleteds: 'Excluídos',
            canceled: 'Cancelado',
            canceleds: 'Cancelados',
        },
        expanded: {
            title: 'Informações do cliente',
            'login-code': 'Código de login',
            document: 'Documento',
            email: 'Email:',
        },
        form: {
            labels: {
                name: 'Nome',
                'trade-name': 'Nome Fantasia',
                legal_name: 'Razão Social',
                cpf: 'CPF',
                cnpj: 'CNPJ',
                'legal-person': 'Pessoa Jurídica',
                'normal-person': 'Pessoa Física',
                email: 'Email',
                phone: 'Telefone',
            },

            buttons: {
                clean: 'Limpar',
                save: 'Salvar',
            },
        },
        show: {
            'title-prefix': 'Dados',
        },
        plan: {
            title: 'Plano Ativo',
            'last-plan-name': 'Último plano selecionado',
            'plan-select-date': 'Data da seleção',
            'plan-value': 'Valor do plano',
            'plan-value-total': 'Valor total',
            'plan-value-discount': 'Valor com desconto',
            'plan-value-cplug': 'Valor a pagar para Cplug',
            'plan-value-customer': 'Valor cobrar do cliente',
            'payment-day': 'Dia para pagamento',
            modules: {
                title: 'Detalhes do Plano',
                table: {
                    headers: {
                        module: 'Módulo',
                        amount: 'Quantidade',
                        price: 'Preço',
                        value: 'Valor',
                        'cplug-value': 'Valor a pagar CPlug',
                        'customer-value': 'Valor a cobrar do cliente',
                    },
                },
                discount: 'Desconto',
                'total-discount': 'Total com desconto',
                total: 'Total',
            },
        },
    },

    user: {
        'table-texts': {
            name: 'Nome',
            email: 'Email',
        },
    },

    /** DIALOGS */
    'dialogs-confirm': {
        buttons: {
            no: 'Não',
            yes: 'Sim',
            confirm: 'Confirmar',
            cancel: 'Cancelar',
            remove: 'Remover',
            restore: 'Restaurar',
        },
    },

    'dialog-plan-logs': {
        table: {
            name: 'Nome',
            modules: 'Módulos',
            date: 'Data Ativação',
            value: 'Valor',
        },
        texts: {
            title: 'Histórico de alterações',
            empty: 'Não há dados disponíveis',
        },
        buttons: {
            show: 'Histórico de Alterações',
        },
    },

    'dialogs-action-log-detail': {
        'title-prefix': 'Detalhes da log',
    },
    /** /DIALOGS */

    'sarala-table': {
        labels: {
            search: 'Pesquisar',
        },
    },

    login: {
        texts: {
            title: 'Entrar',
            resale: 'ADMIN Parceria ConnectPlug',
        },

        labels: {
            'tenant-code': 'Código da empresa',
            email: 'Email',
            password: 'Senha',
        },

        buttons: {
            submit: 'Entrar',
            'forget-password': 'Perdeu a senha?',
        },

        bus: {
            'login-error': 'Preencha o formulário corretamente.',
            'credentials-error': 'Credenciais inválidas.',
        },

        messages: {
            'tenant-code-error-required': 'Código da empresa é obrigatório.',
            'email-error-required': 'Email é obrigatório.',
            'email-error-email': 'Email deve conter um email válido.',
            'password-error-required': 'Senha é obrigatória.',
        },
    },

    'forget-password': {
        texts: {
            title: 'Resetar Senha',
            resale: 'ADMIN Parceria ConnectPlug',
        },

        labels: {
            email: 'Email',
        },

        buttons: {
            submit: 'Resetar',
            login: 'Voltar para o login',
        },

        bus: {
            'forget-password-error': 'Preencha o formulário corretamente.',
            'requisition-error':
                'Não foi possível fazer o pedido de recuperação de senha.',
        },

        messages: {
            'email-error-required': 'Email é obrigatório.',
            'email-error-email': 'Email deve conter um email válido.',
        },

        actions: {
            login: 'Voltar ao login',
        },
    },

    'reset-password': {
        texts: {
            title: 'Resetar Senha',
            resale: 'ADMIN Parceria ConnectPlug',
        },

        labels: {
            password: 'Senha',
            password_confirmation: 'Confirmação da senha',
        },

        buttons: {
            submit: 'Resetar',
            login: 'Voltar para o login',
        },

        bus: {
            'request-error': 'Não foi possível alterar a sua senha.',
            'reset-password-success': 'Senha alterada com sucesso.',
        },
    },

    dashboard: {
        partners: 'Parceiros',
        'partners-without-activation': 'Parceiros sem Ativações',
        'partners-without-activation-text':
            'Parceiros sem ativações (90 dias+)',
        'internal-users': 'Usuários internos',
        'customers-active': 'Clientes Ativos',
        'customers-active-month': 'Clientes Ativos no Mês',
        'customers-blocked': 'Clientes Bloqueados',
        'customers-blocked-month': 'Clientes Bloqueados no Mês',
        'customers-canceled': 'Clientes Cancelados',
        'customers-canceled-month': 'Clientes Cancelados no Mês',
        'product-sales': 'Vendas de Produtos',
        'product-sales-month': 'Vendas de Produtos no Mês',
        'pending-cancellation-requisitions':
            'Pedidos de Cancelamento Pendentes',
        hints: {
            'with-blocked': 'Contabiliza clientes bloqueados',
        },
    },

    'users-form': {
        texts: {
            title: '{title-prefix} Usuário',
        },

        labels: {
            name: 'Nome',
            email: 'Email',
            password: 'Senha',
            'password-confirmation': 'Confirmação da senha',
        },

        buttons: {
            clean: 'Limpar',
            save: 'Salvar',
        },

        bus: {
            'save-success': 'Usuário {name} editado com sucesso.',
        },

        messages: {
            'name-error-required': 'O nome é obrigatório',
            'email-error-required': 'O email é obrigatório',
            'email-error-email': 'O email deve ser válido',
            'password-error-required': 'A senha é obrigatória',
            'password-error-min-length':
                'A senha deve ter no mínimo 6 caracteres',
            'password-error-confirmation': 'As senhas devem concidir',
        },
    },

    'users-index': {
        buttons: {
            create: 'Adicionar usuário',
        },

        bus: {
            'delete-error': 'Erro ao remover o usuário {name}.',
            'delete-success': 'Usuário {name} removido com sucesso.',
        },

        messages: {
            delete: 'Remover?',
            'delete-confirmation':
                'Tem certeza que deseja remover o usuário {name}',
        },
    },

    'users-create': {
        texts: {
            'title-prefix': 'Adicionar',
        },
    },

    'users-edit': {
        texts: {
            'title-prefix': 'Editar',
        },
    },

    modules: {
        routes: {
            index: 'modulos',
            edit: 'modulos/editar',
        },
        breadcrumbs: {
            index: 'Módulos',
        },

        index: {
            table: {
                headers: {
                    name: 'Nome',
                    'original-price': 'Preço CPlug',
                    'partner-price': 'Preço Parceiro',
                    'whitelabel-price': 'Preço White label',
                    partner: 'Parceiro',
                    whitelabel: 'White label',
                },
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Módulo',
                loading: 'Carregando módulos',
            },
            labels: {
                name: 'Nome',
                'original-price': 'Preço CPlug',
                'partner-price': 'Preço Parceiro',
                'whitelabel-price': 'Preço White label',
                'price-type': 'Precificação',
                'charge-from': 'Cobrar a partir de',
                included: 'Inclusos por padrão',
                partner: 'Ativo para Parceiros',
                whitelabel: 'Ativo para White Label',
                'update-on-plans': 'Atualizar nos planos',
                type: 'Tipo',
                'enable-by': 'Ativado para módulo',
                activate: 'Dependências',
                'third-party-apps': 'Aplicativos de Parceiros',
            },
            hint: {
                'enable-by':
                    'Quando o módulo abaixo for selecionado no plano, o módulo {module} será incluído também',
                activate: 'Ao ativar este modulo, ativar também:',
            },
            fields: {
                'price-type': {
                    values: [
                        { text: 'Fixo', value: 'flat', hint: '' },
                        { text: 'Por Unidade', value: 'per_unit', hint: '' },
                    ],
                },
                type: {
                    values: [
                        {
                            text: 'Base',
                            value: 'base_price',
                            hint: 'Peço base do plano',
                        },
                        {
                            text: 'Fixo',
                            value: 'fixed',
                            hint: '',
                        },
                        {
                            text: 'Opcional',
                            value: 'optional',
                            hint: '',
                        },
                        {
                            text: 'Opcional Quantidade',
                            value: 'optional_extra',
                            hint:
                                'Módulo opcional que é cobrado por quantidade',
                        },
                        {
                            text: 'Opcional não selecionável',
                            value: 'optional_hidden',
                            hint:
                                'Módulo opcional que não pode ser selecionado',
                        },
                        { text: 'Totem', value: 'totem', hint: '' },
                        { text: 'Usuários', value: 'users', hint: '' },
                        { text: 'Notas Fiscais', value: 'invoices', hint: '' },
                        {
                            text: 'Não selecionável',
                            value: 'hidden',
                            hint: 'Módulo que não pode ser selecionado',
                        },
                        { text: 'App', value: 'app', hint: '' },
                    ],
                },
            },
            placeholders: {
                type: 'Selecione um tipo...',
                'price-type': 'Selecione uma precificação...',
            },
            errors: {
                'partner-price': {
                    required: 'O preço do parceiro é obrigatório',
                    between: 'O valor deve ser entre 0 e 99999999,99',
                },
                'whitelabel-price': {
                    required:
                        'O preço do white label é obrigatório quando o módulo está disponível para white label',
                    between: 'O valor deve ser entre 0 e 99999999,99',
                },
                type: {
                    required: 'O campo tipo é obrigatório.',
                },
                'price-type': {
                    required: 'O campo precificação é obrigatório.',
                },
                partner: {
                    required: 'O campo ativo para parceiro é obrigatório.',
                },
                whitelabel: {
                    required: 'O campo ativo para white label é obrigatório.',
                },
                'third-party': {
                    required: 'O campo aplicativos de parceiros é obrigatório.',
                },
                included: {
                    between: 'O valor deve ser entre 0 e 20',
                },
                charge_from: {
                    between: 'O valor deve ser entre 0 e 20',
                },
            },
            feedback: {
                success: 'Módulo {name} editado com sucesso.',
                'success-batch': 'Módulos editados com sucesso.',
            },
        },
    },

    planPackages: {
        routes: {
            index: 'pacotes-de-planos',
            create: 'pacotes-de-planos/criar',
            edit: 'pacotes-de-planos/editar',
        },
        breadcrumbs: {
            index: 'Pacotes de Planos',
            modules: 'Módulos do Pacote',
        },
        actions: {
            'show-modules': 'Mostrar módulos do pacote',
        },
        index: {
            table: {
                headers: {
                    name: 'Nome',
                    price: 'Preço',
                    available_for_selection: 'Disponível para seleção',
                },
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Pacote de Plano',
                'title-modules': 'Módulos do Pacote {plan}',
            },
            labels: {
                name: 'Nome',
                price: 'Preço',
                order: 'Ordem',
                corporate: 'Plano Corporativo',
                available_for_selection: 'Disponível para seleção',
                default_anual_discount: 'Desconto anual padrão (%)',
                config_price: 'Valor de Treinamento e Configuração Inicial',
                description: 'Descrição',
                max_installments: 'Máximo de parcelas',
            },
            errors: {
                name: {
                    required: 'O nome é obrigatório.',
                },
            },
            feedback: {
                success: 'Pacote {name} salvo com sucesso.',
            },
        },
    },

    planPackageModules: {
        routes: {
            index: 'pacotes-de-planos/:id/modulos',
            edit: 'pacotes-de-planos/:id/modulos/editar/:module',
            create: 'pacotes-de-planos/:id/modulos/criar',
            'batch-create': 'pacotes-de-planos/:id/modulos/criar-em-lote',
        },
        index: {
            table: {
                headers: {
                    module: 'Módulo',
                    price: 'Preço',
                    price_type: 'Tipo de Precificação',
                    included: 'Incluso',
                    add_on: 'Opcional',
                },
                values: {
                    price_type: {
                        flat: 'Valor fixo',
                        unit: 'Valor por unidade',
                        range: 'Valor por faixa',
                    },
                },
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Módulo do Pacote',
            },
            labels: {
                module: 'Módulo',
                price: 'Preço',
                amount: 'Quantidade',
                max_amount: 'Quantidade Máxima',
                order: 'Ordem de exibição',
                add_on: 'Opcional (add-on)',
                price_type: 'Seleção',
                dependency: 'Dependências',
                courtesy: 'Cortesia',
                combo: 'Combo',
            },
            feedback: {
                success: 'Módulo do pacote salvo com sucesso.',
            },
        },
        actions: {
            'batch-create': 'Adicionar em lote',
        },
    },

    'bank-account': {
        routes: {
            index: 'contas-bancarias',
            create: 'contas-bancarias/:reseller_id/criar',
            edit: 'contas-bancarias/:reseller_id/editar',
        },
        breadcrumbs: {
            index: 'Contas Bancárias',
            create: 'Criar',
            edit: 'Editar',
            show: 'Dados',
        },

        tooltip: {
            'see-all': 'Ver todas as contas',
        },

        index: {
            buttons: {
                create: 'Adicionar Conta Bancária',
            },
            table: {
                holder: 'Titular',
                name: 'Nome',
                bank: 'Banco',
                agency: 'Agência',
                'account-number': 'Conta',
                document: 'CNPJ',
                pix: 'Pix',
                'bank-code': 'Código',
                active: 'Ativa',
                'active-yes': 'SIM',
                'active-no': 'NÃO',
            },
            loading: 'Carregando...',

            filters: {
                all: 'Todas',
                active: 'Ativas',
                inactive: 'Inativas',
            },

            bus: {
                'delete-error':
                    'Erro ao remover a conta bancária {bank-account}.',
                'delete-success':
                    'Conta bancária {bank-account} removida com sucesso.',
                'restore-error':
                    'Erro ao restaurar a conta bancária {bank-account}.',
                'restore-success':
                    'Conta bancária {bank-account} restaurada com sucesso.',
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover a conta {bank-account}?',
                restore: 'Restaurar?',
                'restore-confirmation':
                    'Tem certeza que deseja restaurar a conta {bank-account}?',
                'restore-one-active':
                    'Tem certeza que deseja restaurar a conta {bank-account}? Só é permitido ter uma conta bancária ativa. Ao restaurar essa conta, todas as outras contas serão desativadas.',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Conta Bancária',
            },

            labels: {
                name: 'Nome',
                bank: 'Banco',
                agency: 'Agência',
                'account-number': 'Número da Conta',
                document: 'CNPJ',
                pix: 'Pix',
                active: 'Ativa',
                yes: 'Sim',
                no: 'Não',
            },

            hint: {
                name: 'Nome do titular da conta',
                'account-number': 'Número da conta com o dígito verificador',
                document: 'CNPJ da empresa',
            },

            buttons: {
                save: 'Salvar',
            },

            bus: {
                'save-success':
                    'Conta bancária {bank-account} salva com sucesso.',
            },

            errors: {
                'name-required': 'O nome é obrigatorio.',
                'name-max-length': 'O nome deve ter no máximo 100 caracteres.',
                'bank-id-required-if':
                    'O banco é obrigatório se a agência for informada.',
                'agency-required-if':
                    'A agência é obrigatória se o número da conta for informado.',
                'agency-max-length':
                    'A agência deve ter no máximo 10 caracteres.',
                'account-number-required-if':
                    'O número da conta é obrigatório se a agência for informada.',
                'account-number-max-length':
                    'O número da conta deve ter no máximo 20 caracteres.',
                'document-required-if':
                    'O CNPJ é obrigatório se a agência for informada.',
                'document-max-required':
                    'O documento deve ter no máximo 18 caracteres.',
                'pix-max-length': 'O pix deve ter no máximo 100 caracteres.',
            },
        },
        dialogs: {
            buttons: {
                'one-active': 'Sim, ativar essa conta',
            },
            messages: {
                'one-active': {
                    title: 'Confirmar conta ativa',
                    text:
                        'Só é permitido ter uma conta bancária ativa. Ao salvar essa conta, as outras serão automaticamente desativadas. Deseja continuar?',
                },
            },
        },
    },

    roles: {
        routes: {
            index: 'perfis-de-usuario',
            create: 'perfis-de-usuario/criar',
            edit: 'perfis-de-usuario/editar',
        },
        breadcrumbs: {
            index: 'Perfis de usuário',
            create: 'Criar',
            edit: 'Editar',
        },

        index: {
            buttons: {
                create: 'Adicionar Perfil de usuário',
            },
            table: {
                name: 'Nome',
            },
            loading: 'Carregando...',

            filters: {
                active: 'Ativos',
                inactive: 'Inativos',
            },

            bus: {
                delete: {
                    error: 'Erro ao remover o perfil de usuário {role}.',
                    success: 'Perfil de usuário {role} removido com sucesso.',
                },
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover o perfil de usuário <strong>{role}</strong>?',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Perfil de Usuário',
                loading: 'Carregando permissões',
            },

            labels: {
                name: 'Nome',
                permissions: 'Permissões',
            },

            bus: {
                'save-success': 'Perfil de usuário {role} salvo com sucesso.',
            },

            errors: {
                'name-required': 'O campo nome é obrigatório.',
                'name-max-length':
                    'O campo nome deve ter no máximo 255 caracteres.',
            },
        },
    },

    files: {
        routes: {
            index: 'materiais-de-apoio',
        },
        breadcrumbs: {
            index: 'Materiais de Apoio',
        },
    },

    medias: {
        index: {
            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover a mídia <strong>{media}</strong>?',
                'delete-success':
                    'A mídia <strong>{media}</strong> foi removida com sucesso.',
            },
        },
        form: {
            buttons: {
                close: 'Fechar',
                create: 'Nova Mídia',
            },
            labels: {
                title: 'Título',
                height: 'Altura',
                width: 'Largura',
                file: 'Arquivo',
                active: 'Ativa',
                description: 'Descrição',
            },

            bus: {
                'save-success':
                    'Mídia <strong>{media}</strong> salva com sucesso.',
            },
        },
    },

    tags: {
        index: {
            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover a tag <strong>{tag}</strong>?',
                'delete-success':
                    'A tag <strong>{tag}</strong> foi removida com sucesso.',
            },
        },
        form: {
            buttons: {
                close: 'Fechar',
                create: 'Nova Tag',
            },

            bus: {
                'save-success': 'Tag <strong>{tag}</strong> salva com sucesso.',
            },
        },
    },

    products: {
        routes: {
            create: 'produto/:customer_id/criar',
            edit: 'produto/:customer_id/editar',
        },
        breadcrumbs: {
            index: 'Produtos',
            create: 'Criar',
            edit: 'Editar',
        },

        index: {
            buttons: {
                create: 'Adicionar Produto',
            },
            table: {
                name: 'Nome',
                date: 'Data ativação',
                value: 'Valor',
                modules: 'Módulos',
            },
            loading: 'Carregando...',

            filters: {
                active: 'Ativos',
                inactive: 'Inativos',
            },

            bus: {
                delete: {
                    error: 'Erro ao remover o product {product}.',
                    success: 'Produto {product} removido com sucesso.',
                },
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover o produto <strong>{product}</strong>?',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Produto',
                loading: 'Carregando produtos',
            },

            labels: {
                'external-key': 'Identificador',
                product: 'Produto',
                consultant: 'Consultor',
                value: 'Valor',
            },
            hint: {
                'external-key':
                    'Código de identificação da assinatura do cliente',
            },

            bus: {
                'save-success': 'Produto {product} salvo com sucesso.',
            },

            errors: {
                'product-required': 'O campo produto é obrigatório.',
                'consultant-required': 'O campo consultor é obrigatório.',
                'value-required': 'O campo valor é obrigatório.',
                'external_key-required': 'O campo identificador é obrigatório.',
                'external_key-maxLength':
                    'O campo identificador deve ter no máximo 64 caracteres.',
            },
        },
    },

    'action-log': {
        routes: {
            index: 'logs',
        },

        breadcrumbs: {
            index: 'Logs',
        },

        index: {
            table: {
                userName: 'Usuário',
                action: 'Ação',
                actioned_at: 'Data da Ação',
                actionable_id: 'ID do Recurso',
                resource: 'Recurso',
                original: 'Original',
                changes: 'Modificações',
            },

            texts: {
                'show-log-details': 'Exibir detalhes',
            },
        },

        attributes: {
            userName: {
                system: 'Sistema',
            },
            action: {
                created: 'Criou',
                updated: 'Atualizou',
                deleted: 'Excluiu',
                restored: 'Restaurou',
            },
        },
    },

    commissions: {
        configurations: {
            routes: {
                index: 'comissoes/configuracoes',
                edit: 'comissoes/configuracoes/editar',
            },
            breadcrumbs: {
                index: 'Configurações de Comissão',
                edit: 'Editar',
            },

            index: {
                table: {
                    licenses: 'Licenças',
                    periods: 'Mensalidades',
                    commission_cycle: 'Ciclo de Comissão',
                    fixed_category_payment_limit: 'Limite Categoria Fixa',
                },
            },

            form: {
                texts: {
                    title: 'Configurações de Comissão',
                },

                hint: {
                    licenses:
                        'Quantidade de licenças que o parceiro precisa ter ativas para começar a receber comissão mensal',
                    periods:
                        'Quantidade de mensalidades que o cliente do perceiro precisa pagar para o parceiro receber comissão mensal',
                    commission_cycle:
                        'Período para apuração de clientes que define a comissão por quantidade de clientes do parceiro',
                    fixed_category_payment_limit:
                        'Limite de mensalidades pagas pelos clientes de parceiros com categoria fixa. Após esse limite, não será mais pago comissão sobre o cliente',
                },

                bus: {
                    'save-success':
                        'Configuração de comissão salva com sucesso.',
                },

                errors: {
                    'licences-between':
                        'O campo licenças deve ter um valor entre 1 e 500.',
                    'periods-between':
                        'O campo mensalidades deve ter um valor entre 0 e 12.',
                    'commission-cycle-between':
                        'O campo ciclo de comissão deve ter um valor entre 0 e 12.',
                    'fixed-category-payment-limit-between':
                        'O campo limite categoria fixa deve ter um valor entre 0 e 60 meses.',
                },
            },
        },
        taxes: {
            routes: {
                index: 'comissoes/taxas',
            },
            breadcrumbs: {
                index: 'Taxas/Imposto',
            },
        },
    },

    plans: {
        routes: {
            index: 'planos',
            edit: 'planos/editar',
            module: 'planos/:id/modulos',
            'module-edit': 'planos/:id/modulos/:module',
        },
        breadcrumbs: {
            index: 'Planos',
            modules: 'Modulos do Plano',
        },
        actions: {
            'show-modules': 'Mostrar módulos do plano',
        },

        index: {
            table: {
                name: 'Nome',
            },
        },

        form: {
            texts: {
                title: '{title-prefix} Plano',
                'title-module': 'Módulos do Plano {plan}',
                loading: 'Carregando planos',
            },

            labels: {
                'plan-name': 'Nome do Plano',
                partner: 'Ativo para Parceiro',
                whitelabel: 'Ativo para White Label',
            },
            errors: {
                partner: {
                    required: 'O campo ativo para parceiro é obrigatório.',
                },
                whitelabel: {
                    required: 'O campo ativo para white label é obrigatório.',
                },
            },
            feedback: {
                success: 'Plano {name} editado com sucesso.',
                'success-batch': 'Planos editados com sucesso.',
                modules: 'Modulos do plano {name} editados com sucesso.',
            },
        },
    },

    cnae: {
        routes: {
            index: 'cnae',
        },
    },
}
